import {Injectable} from '@angular/core';
import get from 'lodash-es/get';

import {PayExecLegacy} from '../../../+payrolls';
import {PayExecType} from '../../../+payrolls/analyze/pay-results.model';
import {DATE_MIN} from '../../../app.constants';
import {PayPeriodContract, PayStatus} from '../employees.model';

@Injectable({
  providedIn: 'root'
})
export class PayExecUtils {

  private GOOD_EXECUTION_STATUSES = [PayStatus.ALERT, PayStatus.DONE, PayStatus.FROZEN, PayStatus.CLOSED];

  public setPayTypesOnPayExecs(payExecs: PayExecLegacy[], payPeriodContracts: PayPeriodContract[]): PayExecLegacy[] {
    if (!payPeriodContracts) {
      return payExecs;
    }
    if (!payExecs) {
      return [];
    }
    return payExecs.map((payExec: PayExecLegacy) => {
      payPeriodContracts.forEach((ppc: PayPeriodContract) => {
        if (payExec.attributes.payPeriodContract === ppc.id) {
          payExec.attributes.payTypeName = ppc.payTypeName;
        }
      });
      return payExec;
    });
  }

  public findLastGoodExecutionIds(payExecs: PayExecLegacy[]): number[] {
    if (!payExecs) {
      return null;
    }

    // Map<PayRollType+PayTypeName, PayExec>
    const lastGoodExecutions: Map<string, PayExecLegacy> = new Map();

    payExecs
      .filter((payExec: PayExecLegacy) => this.isGoodPayExec(payExec))
      .forEach((payExec: PayExecLegacy) => {

        const payExecComputeDate = get(payExec, 'attributes.payState.computeDate', DATE_MIN);

        if (!lastGoodExecutions.get(payExec.attributes.payRollType + payExec.attributes.payTypeName)) {

          lastGoodExecutions.set(payExec.attributes.payRollType + payExec.attributes.payTypeName, payExec);

        } else {

          const lastGoodPayExecComputeDate = get(lastGoodExecutions.get(
              payExec.attributes.payRollType + payExec.attributes.payTypeName),
            'attributes.payState.computeDate',
            DATE_MIN);

          if (payExecComputeDate.localeCompare(lastGoodPayExecComputeDate) > 0) {
            lastGoodExecutions.set(payExec.attributes.payRollType + payExec.attributes.payTypeName, payExec);
          }

        }
      });

    return Array.from(lastGoodExecutions)
      .map(([key, value]) => ({key, value}))
      .map(payExec => payExec.value.id);
  }

  public isGoodPayExec(payExec: PayExecLegacy): boolean {
    if (!payExec?.attributes?.payTypeName) {
      return false;
    }
    if (!this.GOOD_EXECUTION_STATUSES.includes(payExec.attributes.payState.status)) {
      return false;
    }
    return [PayExecType.NORMAL, PayExecType.RETROACTIVITY].includes(payExec.attributes.payRollType);
  }
}
